var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"mb-4 md:mb-0",attrs:{"color":"primary","type":"border"},on:{"click":function($event){return _vm.printPdf()}}},[_vm._v("พิมพ์ใบเสร็จที่เลือก (LQ310)")])
}
var staticRenderFns = []

export { render, staticRenderFns }